/* Definiciones GraphQL para worklogs, autorizaciones y dominios */
import { gql } from "@apollo/client";

/* Consulta unificada: trae worklogs personales, generales y autorizaciones en una sola peticion */
export const WORKLOGS_UNIFIED = gql`
  query WorklogsUnified(
    $wherePersonal: worklogWhereInput
    $whereGeneral: worklogWhereInput
    $whereAuth: worklog_authorizationWhereInput
    $orderByWorklog: [worklogOrderByInput!]
    $orderByAuth: [worklog_authorizationOrderByInput!]
  ) {
    personalWorklogs: worklogs(where: $wherePersonal, orderBy: $orderByWorklog) {
      id
      row_version
      user_id
      user_name
      start_time
      end_time
      total_hours
      status
      company_id
      company_name
      product
      project
      general_activity
      activity_objective
      specific_activity
      observation
      extra_time
      extra_start_time
      extra_end_time
      end_time
      extras
      user_updated
      user_deleted
      user_created
      created_at
      updated_at
      deleted_at
    }
    generalWorklogs: worklogs(where: $whereGeneral, orderBy: $orderByWorklog) {
      id
      row_version
      user_id
      user_name
      start_time
      end_time
      total_hours
      status
      company_id
      company_name
      product
      project
      general_activity
      activity_objective
      specific_activity
      observation
      extra_time
      extra_start_time
      extra_end_time
      end_time
      extras
      user_updated
      user_deleted
      user_created
      created_at
      updated_at
      deleted_at
    }
    worklogAuthorizations(orderBy: $orderByAuth, where: $whereAuth) {
      id
      row_version
      date
      user_id
      user_name
      auth_user_id
      auth_user_name
      total_hours
      daily_limit_hours
      user_updated
      user_deleted
      user_created
      created_at
      updated_at
    }
  }
`;

// Consulta de tareas pendientes (tabla worklog_pending)
export const PENDING_TASKS_QUERY = gql`
  query WorklogPendings(
    $where: worklog_pendingWhereInput
    $orderBy: [worklog_pendingOrderByInput!]
  ) {
    pendingTasks: worklogPendings(where: $where, orderBy: $orderBy) {
      id
      row_version
      company_id
      company_name
      user_id
      user_name
      product
      activity_type
      request_source
      task_name
      status
      ticket_id
      planned_date
      closing_date
      duration
      is_recurring
      recurring_frequency
      recurring_end_date
      recurring_source_id
      created_at
      user_created
      user_updated
      updated_at
      deleted_at
    }
  }
`;

// Consulta simple de worklogs (usada en el modal de inicio/fin de jornada y en fetchChunk)
export const WORKLOGS = gql`
    query Worklogs($where: worklogWhereInput, $orderBy: [worklogOrderByInput!]) {
      worklogs(where: $where, orderBy: $orderBy) {
        id
        row_version
        user_id
        user_name
        start_time
        end_time
        total_hours
        status
        company_id
        company_name
        product
        project
        general_activity
        activity_objective
        specific_activity
        observation
        extra_time
        extra_start_time
        extra_end_time
        end_time
        extras
        user_updated
        user_deleted
        user_created
        created_at
        updated_at
        deleted_at
      }
    }
  `;

// Consulta de autorizaciones de horas extra (incluye row_version para fetchChunk)
export const WORKLOGS_AUTORIZATION = gql`
  query WorklogAuthorizations(
    $orderBy: [worklog_authorizationOrderByInput!]
    $where: worklog_authorizationWhereInput
  ) {
    worklogAuthorizations(orderBy: $orderBy, where: $where) {
      id
      row_version
      date
      user_id
      user_name
      auth_user_id
      auth_user_name
      total_hours
      daily_limit_hours
      user_updated
      user_deleted
      user_created
      created_at
      updated_at
      deleted_at
    }
  }
`;

// Suscripciones en tiempo real (Phase 5)
export const WORKLOG_CHANGED_SUBSCRIPTION = gql`
  subscription WorklogChanged {
    worklogChanged {
      id
      row_version
      user_id
      user_name
      start_time
      end_time
      total_hours
      status
      company_id
      company_name
      product
      project
      general_activity
      activity_objective
      specific_activity
      observation
      extra_time
      extra_start_time
      extra_end_time
      end_time
      extras
      user_updated
      user_deleted
      user_created
      created_at
      updated_at
      deleted_at
    }
  }
`

export const WORKLOG_AUTH_CHANGED_SUBSCRIPTION = gql`
  subscription WorklogAuthorizationChanged {
    worklogAuthorizationChanged {
      id
      row_version
      date
      user_id
      user_name
      auth_user_id
      auth_user_name
      total_hours
      daily_limit_hours
      user_updated
      user_deleted
      user_created
      created_at
      updated_at
      deleted_at
    }
  }
`

export const GENERATE_REGISTRO_HORAS_REPORT = gql`
  mutation GenerateRegistroHorasReport($process: String!, $where: JSON!, $export: Boolean!) {
    generateReport(payload: { process: $process, params: $where, exports: $export })
  }
`

// --- Mutaciones individuales ---
export const CREATE_WORKLOG = gql`
  mutation CreateOneWorklog($data: worklogCreateInput!) {
    createOneWorklog(data: $data) {
      id
    }
  }
`;

export const UPDATE_WORKLOG = gql`
  mutation UpdateOneWorklog(
    $data: worklogUpdateInput!
    $where: worklogWhereUniqueInput!
  ) {
    updateOneWorklog(data: $data, where: $where) {
      id
    }
  }
`;

// --- Mutaciones masivas (usadas al guardar desde la hoja de calculo) ---
export const CREATE_MANY_WORKLOG = gql`
  mutation CreateManyWorklog($data: [WorklogCreateManyInput!]!) {
    createManyWorklog(data: $data) {
      count
    }
  }
`;

export const DELETE_MANY_WORKLOG = gql`
  mutation DeleteManyWorklog($idsList: idsList!) {
    deleteManyWorklog(IdsList: $idsList)
  }
`;

export const UPDATE_MANY_WORKLOG = gql`
  mutation UpdateManyWorklog($payload: [UpdateManyWorklogItem!]!) {
    updateManyWorklog(payload: $payload)
  }
`;

export const CREATE_MANY_WORKLOG_AUTH = gql`
  mutation CreateManyWorklog_authorization($data: [Worklog_authorizationCreateManyInput!]!) {
    createManyWorklog_authorization(data: $data) {
      count
    }
  }
`;

export const UPDATE_MANY_WORKLOG_AUTH = gql`
  mutation UpdateManyWorklog_authorization($payload: [UpdateManyWorklog_authorizationItem!]!) {
    updateManyWorklog_authorization(payload: $payload)
  }
`;

export const DELETE_MANY_WORKLOG_AUTH = gql`
  mutation DeleteManyWorklog_authorization($idsList: idsList!) {
    deleteManyWorklog_authorization(IdsList: $idsList)
  }
`;

// --- Mutaciones masivas para tareas pendientes (worklog_pending) ---
export const CREATE_MANY_PENDING_TASK = gql`
  mutation CreateManyWorklogPending($data: [Worklog_pendingCreateManyInput!]!) {
    createManyWorklog_pending(data: $data) {
      count
    }
  }
`;

export const UPDATE_MANY_PENDING_TASK = gql`
  mutation UpdateManyWorklogPending($payload: [UpdateManyWorklog_pendingItem!]!) {
    updateManyWorklog_pending(payload: $payload)
  }
`;

export const DELETE_MANY_PENDING_TASK = gql`
  mutation DeleteManyWorklogPending($idsList: idsList!) {
    deleteManyWorklogPending(IdsList: $idsList)
  }
`;

// --- Mutaciones versionadas por fila (Phase 4) ---

export const UPDATE_WORKLOG_VERSIONED = gql`
  mutation UpdateWorklogVersioned(
    $id: String!
    $expectedRowVersion: Int!
    $data: worklogUpdateInput!
  ) {
    updateWorklogVersioned(id: $id, expectedRowVersion: $expectedRowVersion, data: $data) {
      ok
      errorCode
      fieldErrors {
        field
        code
        message
      }
      row {
        id
        row_version
        user_id
        user_name
        start_time
        end_time
        total_hours
        status
        company_id
        company_name
        product
        project
        general_activity
        activity_objective
        specific_activity
        observation
        extra_time
        extra_start_time
        extra_end_time
        extras
        user_updated
        user_deleted
        user_created
        created_at
        updated_at
        deleted_at
      }
    }
  }
`;

export const DELETE_WORKLOG_VERSIONED = gql`
  mutation DeleteWorklogVersioned($id: String!, $expectedRowVersion: Int!) {
    deleteWorklogVersioned(id: $id, expectedRowVersion: $expectedRowVersion) {
      ok
      errorCode
    }
  }
`;

export const WORKLOG_BY_ID = gql`
  query WorklogById($id: String!) {
    worklogs(where: { id: { equals: $id } }) {
      id
      row_version
      user_id
      user_name
      start_time
      end_time
      total_hours
      status
      company_id
      company_name
      product
      project
      general_activity
      activity_objective
      specific_activity
      observation
      extra_time
      extra_start_time
      extra_end_time
      end_time
      extras
      user_updated
      user_deleted
      user_created
      created_at
      updated_at
      deleted_at
    }
  }
`;

export const UPDATE_WORKLOG_AUTH_VERSIONED = gql`
  mutation UpdateWorklogAuthVersioned(
    $id: String!
    $expectedRowVersion: Int!
    $data: worklog_authorizationUpdateInput!
  ) {
    updateWorklogAuthorizationVersioned(id: $id, expectedRowVersion: $expectedRowVersion, data: $data) {
      ok
      errorCode
      row {
        id
        row_version
        date
        user_id
        user_name
        auth_user_id
        auth_user_name
        total_hours
        daily_limit_hours
        user_updated
        user_deleted
        user_created
        created_at
        updated_at
      }
    }
  }
`;

export const DELETE_WORKLOG_AUTH_VERSIONED = gql`
  mutation DeleteWorklogAuthVersioned($id: String!, $expectedRowVersion: Int!) {
    deleteWorklogAuthorizationVersioned(id: $id, expectedRowVersion: $expectedRowVersion) {
      ok
      errorCode
    }
  }
`;

export const WORKLOG_AUTH_BY_ID = gql`
  query WorklogAuthById($id: String!) {
    worklogAuthorizations(where: { id: { equals: $id } }) {
      id
      row_version
      date
      user_id
      user_name
      auth_user_id
      auth_user_name
      total_hours
      daily_limit_hours
      user_updated
      user_deleted
      user_created
      created_at
      updated_at
    }
  }
`;

export const UPDATE_WORKLOG_PENDING_VERSIONED = gql`
  mutation UpdateWorklogPendingVersioned(
    $id: String!
    $expectedRowVersion: Int!
    $data: worklog_pendingUpdateInput!
  ) {
    updateWorklogPendingVersioned(id: $id, expectedRowVersion: $expectedRowVersion, data: $data) {
      ok
      errorCode
      row {
        id
        row_version
        company_id
        company_name
        user_id
        user_name
        product
        activity_type
        request_source
        task_name
        status
        ticket_id
        planned_date
        closing_date
        duration
        is_recurring
        recurring_frequency
        recurring_end_date
        recurring_source_id
        created_at
        user_created
        user_updated
        updated_at
        deleted_at
      }
    }
  }
`;

export const DELETE_WORKLOG_PENDING_VERSIONED = gql`
  mutation DeleteWorklogPendingVersioned($id: String!, $expectedRowVersion: Int!) {
    deleteWorklogPendingVersioned(id: $id, expectedRowVersion: $expectedRowVersion) {
      ok
      errorCode
    }
  }
`;

export const WORKLOG_PENDING_BY_ID = gql`
  query WorklogPendingById($id: String!) {
    worklogPendings(where: { id: { equals: $id } }) {
      id
      row_version
      company_id
      company_name
      user_id
      user_name
      product
      activity_type
      request_source
      task_name
      status
      ticket_id
      planned_date
      closing_date
      duration
      is_recurring
      recurring_frequency
      recurring_end_date
      recurring_source_id
      created_at
      user_created
      user_updated
      updated_at
      deleted_at
    }
  }
`;

// Trae usuarios y compañias para poblar las listas de validacion de la hoja
export const GET_USERS_AND_COMPANIES = gql`
  query GetUsersAndCompanies(
    $whereUsers: userWhereInput!
    $whereCompanies: companyWhereInput!
    $firstUsers: Int
    $lastUsers: Int
  ) {
    userss(
      where: $whereUsers
      first: $firstUsers
      last: $lastUsers
    ) {
      id
      nickname
      names
      lastnames
      email
      extras
      company {
        id
        name
      }
    }
    companies(
      where: $whereCompanies
    ) {
      id
      name
      product
    }
  }
`;
